// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 220 ? "178f3383" : chunkId) + "." + {"220":"ad5af454f7219dee","1343":"7a253c39201f94be","3243":"ce95f1575e1fd73d","6094":"a6d2d0affdaaccb0"}[chunkId] + ".js";
};